export default {
    requestError: '请求出现未知错误',
    systemError: '系统服务异常',
    websocketError: 'websocket服务异常，可能无法提供服务',
    unknownError: '操作失败',
    paramError: '输入参数错误，请确认后重试',
    tokenError: '登录过期，请重新登录',
    authenError: '权限不足，请联系管理员',
    systemBusy: '系统繁忙，请稍后重试',
    operationsDeny: '当前处于运维模式，操作被禁止'
}



// WEBPACK FOOTER //
// ./src/config/i18n/zh-cn/error.js